// Должен соответствовать projectName
export const UNIQUE_CONFIG_KEY = 'homeowner-helper-frontend';
